import { useArticles } from "@/hooks/useArticles";
import { ArticleGrid } from "@/components/ArticleGrid";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ArticlesList = () => {
  const { data: articles, isLoading } = useArticles();
  const navigate = useNavigate();

  const filteredArticles = articles?.filter(
    (article) => article.category === "ARTICLES"
  );

  return (
    <div className="min-h-screen relative py-24">
      {/* 光の帯 / ノイズオーバーレイ（Rooms/Topと統一） */}
      <div className="light-band" />
      <div className="noise-overlay" />
      <div className="container px-4 relative z-10">
        <div className="flex items-center mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate("/")}
            className="mr-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            戻る
          </Button>
          <div>
            <h1 className="text-3xl md:text-4xl font-light text-foreground tracking-[0.2em]">
              ARTICLES
            </h1>
            <p className="text-muted-foreground text-sm tracking-[0.2em]">
              メインコンテンツ
            </p>
          </div>
        </div>

        <ArticleGrid
          articles={filteredArticles}
          isLoading={isLoading}
          searchQuery=""
          selectedCategory={null}
        />
      </div>
    </div>
  );
};

export default ArticlesList;